import classnames from 'classnames'

export default function (path, sortPath, ascending ) {
  return classnames({ 
    [`order-${ascending ? 'ascend' : 'descend'}`]: sortPath === path 
  })
}